module.exports = __webpack_public_path__ + "img/IN.e0f1fdb6.svg";